module.exports = "<svg *ngIf=\"iconPath\" focusable=\"false\" style=\"width: 100%;\">\r\n  <use [attr.xlink:href]=\"iconPath\"></use>\r\n</svg>\r\n"